import { registrationUrl } from 'endpoints';
import fetch from '../utils/fetch';

class SelfRegistraionSDK {
  // Get a all registration forms for the client
  getForms = regId => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-forms`, {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`
        }
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( forms => {
              resolve( forms );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
  // Create a client registration form
  createForm = ( data, regId ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-form`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`
        },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( forms => {
              resolve( forms );
            } );
          } else {
            res.json().then( data => {
              reject( data );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Get a client registration form
  getForm = ( formId, regId ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-form/${formId}`, {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`
        }
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( form => {
              resolve( form );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
  // Get a client registration all form attributes by form id with requested properties
  getAttributes = data => {
    const { formId, regId } = data;
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-form/${formId}/attributes`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`
        },
        body: JSON.stringify( { active: false } )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( program => {
              resolve( program );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
  // Update a client registration form
  updateForm = ( data, regId, formId ) => {
    // data.active = true;
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-form/${formId}`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`,
          'form-id': `${formId}`
        },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( program => {
              resolve( program );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Copy a client registration form
  copyForm = ( data, regId, formId ) => {
    // data.active = true;
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-form/${formId}/copy`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`,
          'form-id': `${formId}`
        },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( program => {
              resolve( program );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Update a client registration form
  createAttributes = ( data, regId, formId ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-form/${formId}/attribute`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`,
          'form-id': `${formId}`
        },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( program => {
              resolve( program );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Update a client registration form
  updateAttributes = ( data, regId, formId ) => {
    data = data ? data : { active: true };
    return new Promise( ( resolve, reject ) => {
      fetch(
        `${registrationUrl}/registration-form/${formId}/attribute/${data.formAttributeId}`,
        {
          method: 'PUT',
          headers: {
            'content-type': 'application/json',
            'registration-id': `${regId}`,
            'form-id': `${formId}`
          },
          body: JSON.stringify( data )
        }
      )
        .then( res => {
          if ( res.ok ) {
            res.json().then( program => {
              resolve( program );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
  // Get a Roster maapping fields
  getRosterFields = () => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/roster-fields`, {
        method: 'GET',
        headers: { 'content-type': 'application/json' }
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( fieldNames => {
              resolve( fieldNames );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Get a client registration form attributes object by Attibute id with requested properties
  getAttribute = ( { regId, formId, attributeId } ) => {
    return new Promise( ( resolve, reject ) => {
      fetch(
        `${registrationUrl}/registration-form/${formId}/attribute/${attributeId}`,
        {
          method: 'GET',
          headers: {
            'content-type': 'application/json',
            'registration-id': `${regId}`
          }
        }
      )
        .then( res => {
          if ( res.ok ) {
            res.json().then( attribute => {
              resolve( attribute );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Create sub attribute mapping for the attribute
  createSubAttributeMapping = ( data, attributeId ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/attribute/${attributeId}/subattribute`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            // res.json().then(attributes => {
            //   resolve(attributes);
            // });
          } else {
            res.json().then( data => {
              reject( data );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Update sub attribute mapping for the attribute
  updateSubAttributeMapping = ( data, attributeId ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/attribute/${attributeId}/subattribute`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( attributes => {
              resolve( attributes );
            } );
          } else {
            res.json().then( data => {
              reject( data );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Get all sub attributes for given attribute id
  getSubAttributes = attributeId => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/attribute/${attributeId}/subattributes`, {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        }
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( attributes => {
              resolve( attributes );
            } );
          } else {
            res.json().then( data => {
              reject( data );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Get a  all form sub  attributes by form id with requested properties
  getSubAttributeByFromId = formId => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/registration-form/${formId}/subattributes`, {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        }
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( subAttributes => {
              resolve( subAttributes );
            } );
          } else {
            res.json().then( data => {
              reject( data );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Form Download
  formDownload = ( regId, formId ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/form-download/${formId}`, {
        method: 'GET',
        headers: {
          'content-type': 'application/octet-stream',
          'registration-id': `${regId}`
        },
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( forms => {
              resolve( forms );
            } );
          } else {
            res.json().then( data => {
              reject( data );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Form Upload
  formUpload = ( regId, data ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${registrationUrl}/form-upload`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'registration-id': `${regId}`,
        },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
              resolve( 'Successfully Form Uploaded' );
          } else {
              reject( 'Form Upload Failed' );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
}

export default new SelfRegistraionSDK();
